import type { ApiConfig, FetchApiData, FetchSubTypes } from '../types'
import { binanceJapanExchange } from './constants'
import { convertHistoryApiConfig } from './convertHistory/constants'
import {
  createFetchApiData as createFetchConvertHistoryApiData,
  fetchApiData as fetchConvertHistoryApiData,
} from './convertHistory/fetchApiData'
import { depositHistoryApiConfig } from './depositHistory/constants'
import {
  createFetchApiData as createFetchDepositHistoryApiData,
  fetchApiData as fetchDepositHistoryApiData,
} from './depositHistory/fetchApiData'
import { spotTradeHistoryApiConfig } from './spotTradeHistory/constants'
import {
  createFetchApiData as createFetchSpotTradeHistoryApiData,
  fetchApiData as fetchSpotTradeHistoryApiData,
} from './spotTradeHistory/fetchApiData'
import { fetchSubTypes as fetchSpotTradeHistorySubTypes } from './spotTradeHistory/fetchSubTypes'
import { usdFutureHistoryApiConfig } from './usdFutureHistory/constants'
import { fetchApiData as fetchUsdFutureHistoryApiData } from './usdFutureHistory/fetchApiData'
import { withdrawalHistoryApiConfig } from './withdrawalHistory/constants'
import {
  createFetchApiData as createFetchWithdrawalHistoryApiData,
  fetchApiData as fetchWithdrawalHistoryApiData,
} from './withdrawalHistory/fetchApiData'

export const binanceApiConfigs = {
  [convertHistoryApiConfig.type]: convertHistoryApiConfig,
  [depositHistoryApiConfig.type]: depositHistoryApiConfig,
  [spotTradeHistoryApiConfig.type]: spotTradeHistoryApiConfig,
  [usdFutureHistoryApiConfig.type]: usdFutureHistoryApiConfig,
  [withdrawalHistoryApiConfig.type]: withdrawalHistoryApiConfig,
} as const satisfies Record<string, ApiConfig>

export type BinanceApiType = keyof typeof binanceApiConfigs

export const binanceApiTypes = Object.keys(
  binanceApiConfigs,
) as BinanceApiType[]

export const fetchBinanceApiDataFuncs = {
  [convertHistoryApiConfig.type]: fetchConvertHistoryApiData,
  [depositHistoryApiConfig.type]: fetchDepositHistoryApiData,
  [spotTradeHistoryApiConfig.type]: fetchSpotTradeHistoryApiData,
  [usdFutureHistoryApiConfig.type]: fetchUsdFutureHistoryApiData,
  [withdrawalHistoryApiConfig.type]: fetchWithdrawalHistoryApiData,
} as const satisfies Record<string, FetchApiData>

export const fetchBinanceSubTypesFuncs = {
  [convertHistoryApiConfig.type]: undefined,
  [depositHistoryApiConfig.type]: undefined,
  [spotTradeHistoryApiConfig.type]: fetchSpotTradeHistorySubTypes,
  [usdFutureHistoryApiConfig.type]: undefined,
  [withdrawalHistoryApiConfig.type]: undefined,
} as const satisfies Record<string, FetchSubTypes | undefined>

/** Binance Japan で利用する API 設定 (先物は Binance Japan 非対応のため除外) */
export const binanceJapanApiConfigs = {
  [convertHistoryApiConfig.type]: convertHistoryApiConfig,
  [depositHistoryApiConfig.type]: depositHistoryApiConfig,
  [spotTradeHistoryApiConfig.type]: spotTradeHistoryApiConfig,
  [withdrawalHistoryApiConfig.type]: withdrawalHistoryApiConfig,
} as const satisfies Record<string, ApiConfig>

export type BinanceJapanApiType = keyof typeof binanceJapanApiConfigs

/** Binance Japan で利用する API 種類一覧 */
export const binanceJapanApiTypes: BinanceJapanApiType[] = [
  convertHistoryApiConfig.type,
  depositHistoryApiConfig.type,
  spotTradeHistoryApiConfig.type,
  withdrawalHistoryApiConfig.type,
]

/** Binance Japan の API 種類ごとのデータ取得関数 */
export const fetchBinanceJapanApiDataFuncs = {
  [convertHistoryApiConfig.type]: createFetchConvertHistoryApiData({
    exchange: binanceJapanExchange,
  }),
  [depositHistoryApiConfig.type]: createFetchDepositHistoryApiData({
    exchange: binanceJapanExchange,
  }),
  [spotTradeHistoryApiConfig.type]: createFetchSpotTradeHistoryApiData({
    exchange: binanceJapanExchange,
  }),
  [withdrawalHistoryApiConfig.type]: createFetchWithdrawalHistoryApiData({
    exchange: binanceJapanExchange,
  }),
} as const satisfies Record<BinanceJapanApiType, FetchApiData>

/** Binance Japan の API 種類ごとのサブタイプ取得関数 */
export const fetchBinanceJapanSubTypesFuncs = {
  [convertHistoryApiConfig.type]: undefined,
  [depositHistoryApiConfig.type]: undefined,
  [spotTradeHistoryApiConfig.type]: fetchSpotTradeHistorySubTypes,
  [withdrawalHistoryApiConfig.type]: undefined,
} as const satisfies Record<BinanceJapanApiType, FetchSubTypes | undefined>

export { getCurrentBinanceAssets } from './getCurrentAsset'
